<script>
import BaseView from "@/mixins/BaseView.vue";
import debounce from "lodash.debounce";

export default {
  name: "TruckSelect",
  mixins: [BaseView],
  props: {
    modelValue: Number,
    label: String,
    rules: Array,
    hideDetails: Boolean,
  },
  emits: ["update:modelValue", "change"],
  data() {
    return {
      trucks: [],
      isLoading: false,
      debouncedRequest: () => {},
    };
  },
  computed: {
    model: {
      get() {
        return this.modelValue;
      },
      set(value) {
        this.$emit("update:modelValue", value);
        this.$emit("change", value);
      },
    },
  },
  mounted() {
    this.debouncedRequest = debounce(this.fetchTruck, 300);
  },
  methods: {
    async fetchTruck(numberQuery) {
      this.isLoading = true;
      try {
        const resp = await this.$api.trucks.findTrucks({ number: numberQuery.trim() });
        this.trucks = resp.data.items;
      } catch (error) {
        console.error("Error load trucks list: ", error);
      } finally {
        this.isLoading = false;
      }
    },
    search(numberQuery) {
      this.debouncedRequest(numberQuery);
    },
  },
};
</script>

<template>
  <v-autocomplete
    v-model="model"
    :clearable="true"
    :hide-details="hideDetails"
    :items="trucks"
    :label="label || $t('trucks.number')"
    :loading="isLoading"
    :rules="rules"
    color="primary"
    density="compact"
    item-title="number"
    item-value="id"
    variant="outlined"
    @update:search="search"
  />
</template>

<style scoped></style>
